/* North Valley · ticket médio: "Complete your kit" (PDP) + adição rápida na gaveta do carrinho */
(function () {
  if (window.__nvUpsell) return;
  window.__nvUpsell = true;
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  // Adiciona vários itens de uma vez e atualiza a gaveta do carrinho do Dawn
  async function addItems(items) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents(data);
    } else {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
      return data;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv-upsell', cartData: data });
    }
    return data;
  }

  class NvKit extends HTMLElement {
    connectedCallback() {
      this.currency = this.dataset.currency || 'GBP';
      this.tiers = [];
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]').filter((t) => t.q > 0 && t.p > 0).sort((a, b) => a.q - b.q);
      } catch (e) {}
      try {
        this.mainVariants = JSON.parse(this.querySelector('[data-kit-main]').textContent).variants;
      } catch (e) {
        this.mainVariants = [];
      }
      this.label = this.querySelector('[data-kit-label]').textContent.trim();
      this.formInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);

      this.addEventListener('change', () => this.update());
      this.querySelector('[data-kit-add]').addEventListener('click', () => this.add());
      // O Dawn dispara "change" no input[name=id] quando a variante muda
      this.onVariant = (e) => {
        if (e.target.matches(`#product-form-${this.dataset.section} input[name="id"]`)) this.update();
      };
      document.addEventListener('change', this.onVariant);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariant);
    }

    mainVariant() {
      const input = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
      const id = Number(input && input.value);
      return this.mainVariants.find((v) => v.id === id) || null;
    }

    selected() {
      return [...this.querySelectorAll('[data-kit-item]')]
        .filter((el) => el.querySelector('[data-kit-check]').checked)
        .map((el) => {
          const input = el.querySelector('[data-kit-variant]');
          const opt = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
          return { el, id: Number(input.value), price: Number(opt.dataset.price) };
        });
    }

    update() {
      const mv = this.mainVariant();
      const extras = this.selected();

      // Preço de cada acessório acompanha o tamanho escolhido
      this.querySelectorAll('[data-kit-item]').forEach((el) => {
        const input = el.querySelector('[data-kit-variant]');
        const opt = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        el.querySelector('[data-kit-price]').textContent = money(Number(opt.dataset.price), this.currency);
        const image = el.querySelector('[data-kit-image]');
        if (image && opt.dataset.image) { image.src = opt.dataset.image; image.alt = opt.dataset.alt || ''; }
        el.classList.toggle('is-off', !el.querySelector('[data-kit-check]').checked);
      });

      const mainTitle = this.querySelector('[data-kit-main-title]');
      const mainPrice = this.querySelector('[data-kit-main-price]');
      if (mv) {
        mainTitle.textContent = mv.title;
        mainPrice.textContent = money(mv.price, this.currency);
        const image = this.querySelector('[data-kit-main-image]');
        if (image && mv.image) { image.src = mv.image; image.alt = mv.alt; }
      } else {
        mainTitle.textContent = 'Select your size above';
      }

      const count = (mv ? 1 : 0) + extras.length;
      const subtotal = (mv ? mv.price : 0) + extras.reduce((s, x) => s + x.price, 0);
      const tier = [...this.tiers].reverse().find((t) => count >= t.q);
      const next = this.tiers.find((t) => count < t.q);
      const total = tier ? Math.round(subtotal * (1 - tier.p / 100)) : subtotal;

      this.querySelector('[data-kit-total]').textContent = money(total, this.currency);
      const was = this.querySelector('[data-kit-was]');
      const save = this.querySelector('[data-kit-save]');
      const nudge = this.querySelector('[data-kit-nudge]');
      was.hidden = !tier;
      save.hidden = !tier;
      if (tier) {
        was.textContent = money(subtotal, this.currency);
        save.textContent = `You save ${money(subtotal - total, this.currency)} (${tier.p}% tier)`;
      }
      nudge.hidden = !next;
      if (next) {
        const n = next.q - count;
        nudge.textContent = `Add ${n} more item${n > 1 ? 's' : ''} to save ${next.p}%`;
      }

      const btn = this.querySelector('[data-kit-add]');
      const unavailable = !mv || !mv.available;
      btn.disabled = unavailable || !extras.length;
      this.querySelector('[data-kit-label]').textContent = unavailable
        ? 'Choose an available size'
        : extras.length
        ? `${this.label} · ${count} items`
        : 'Tick an item to build your kit';
    }

    async add() {
      const mv = this.mainVariant();
      if (!mv || !mv.available || !this.selected().length) return;
      const btn = this.querySelector('[data-kit-add]');
      const err = this.querySelector('[data-kit-error]');
      err.hidden = true;
      btn.classList.add('loading');
      btn.disabled = true;
      const items = [{ id: mv.id, quantity: 1, properties: { _nv_source: 'kit' } }].concat(
        this.selected().map((x) => ({ id: x.id, quantity: 1, properties: { _nv_source: 'kit' } }))
      );
      try {
        await addItems(items);
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      } finally {
        btn.classList.remove('loading');
        this.update();
      }
    }
  }
  if (!customElements.get('nv-kit')) customElements.define('nv-kit', NvKit);

  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-nv-variant]')) return;
    const item = e.target.closest('[data-nv-quick-item]');
    const opt = e.target.tagName === 'SELECT' ? e.target.selectedOptions[0] : e.target;
    if (!item || !opt) return;
    const price = item.querySelector('[data-nv-price]');
    if (price) price.textContent = money(Number(opt.dataset.price), item.dataset.currency);
    const image = item.querySelector('[data-nv-image]');
    if (image && opt.dataset.image) { image.src = opt.dataset.image; image.alt = opt.dataset.alt || ''; }
  });

  // Gaveta do carrinho: "+ Add" com 1 clique (delegado, sobrevive ao re-render da gaveta)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nv-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const item = btn.closest('[data-nv-quick-item]');
    const id = Number(item.querySelector('[data-nv-variant]').value);
    btn.disabled = true;
    btn.textContent = '…';
    try {
      await addItems([{ id, quantity: 1, properties: { _nv_source: 'cart-upsell' } }]);
    } catch (err) {
      btn.disabled = false;
      btn.textContent = '+ Add';
      alert(err.message);
    }
  });
})();
